export function isSingleQuotedString(char: string): boolean
{
  return char === "'"
}